module.exports = __webpack_public_path__ + "static/staff_of_healing-a70e6fbdc63d1f9e94d97fd8cc15ff13.jpeg";